import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

GetList.propTypes = {
    giverList: PropTypes.array
};

GetList.defaultProps = {
    giverList: []
}


function GetList(props) {
    const { giverList } = props;
    console.log(giverList)
    return (
        <div >
            {giverList.length > 0 ?
                (giverList.map(giver => (

                    <div className='element-container' >
                        <p className='nom'>Nom           : {giver.name}</p>
                        <p className='tel'>Telephone     : {giver.tel}</p>
                        <p className='dispo'>Disponibilité : {giver.dispo}</p>
                        <p className='type'>Paiment       : {giver.type}</p>
                        <p className='address'>Adress  : <a href={giver.address} target="_blank" ><Button size="small" variant="outlined" color="primary" >{giver.address}</Button></a></p>
                    </div>
                )))
                :
                (<p>Pas de resultat pour cette wilaya</p>)
            }
        </div >
    )
}

export default GetList